import React from 'react'
import {useTranslation} from 'react-i18next'
import {debounce, FormControl, IconButton, InputLabel, MenuItem, Select, TextField} from '@mui/material'
import {Box, Flex} from 'rebass'
import CancelIcon from '@mui/icons-material/Cancel'

type SearchOptions = {
    searchTerm: string | null
    active: boolean | null
}

type Props = {
    onSearch: (searchTerm: SearchOptions) => void
}

export const ReroutingSearch = ({ onSearch }: Props) => {
    const { t } = useTranslation()

    const [searchOptions, setSearchOptions] = React.useState<SearchOptions>({ searchTerm: null, active: null })


    const debouncedFetchData = debounce(async (searchOptions: SearchOptions) => {
        await onSearch(searchOptions)
    }, 400)

    React.useEffect(() => {
        !(searchOptions.searchTerm == null && searchOptions.active == null) && debouncedFetchData(searchOptions)
    }, [searchOptions, debouncedFetchData])

    return (
        <Flex mb={3} justifyContent='space-between' alignItems='center' flexWrap='nowrap'>
            <Box width={[1, 1, 1]} mt={2}>
                <TextField
                    sx={{ mr: 1 }}
                    type='text'
                    size='small'
                    id='outlined-basic'
                    label={`${t('general.search')}...`}
                    variant='outlined'
                    value={searchOptions.searchTerm || ''}
                    autoFocus={false}
                    InputProps={{
                        endAdornment: searchOptions.searchTerm && (
                            <IconButton size='small' onClick={() => setSearchOptions(prev => {
                                return {
                                    searchTerm: '',
                                    active: prev.active,
                                }
                            })}>
                                <CancelIcon />
                            </IconButton>
                        ),
                    }}
                    onChange={e => {
                        setSearchOptions(prev => {
                            return {
                                searchTerm: e.target.value,
                                active: prev.active,
                            }
                        })
                    }}
                />
                <FormControl size='small' sx={{ minWidth: '250px' }}>
                    <InputLabel id='rerouting-number-search-active-label'>{t('rerouting.number.table.active-filter.title')}</InputLabel>
                    <Select
                        labelId='rerouting-number-search-active-label'
                        id='rerouting-number-search-active'
                        value={searchOptions.active === null ? '' : searchOptions.active ? 'true' : 'false'}
                        label={t('rerouting.number.table.active-filter.title')}
                        onChange={e => {
                            const val = e.target.value
                            setSearchOptions(prev => {
                                return {
                                    searchTerm: prev.searchTerm || '',
                                    active: val === '' ? null : val === 'true',
                                }
                            })
                        }}
                    >
                        <MenuItem value={''}>{t('rerouting.number.table.active-filter.all')}</MenuItem>
                        <MenuItem value={'true'}>{t('rerouting.number.table.active-filter.now-or-future')}</MenuItem>
                        <MenuItem value={'false'}>{t('rerouting.number.table.active-filter.not-now-nor-future')}</MenuItem>
                    </Select>
                </FormControl>
            </Box>
        </Flex>
    )
}
